import { MigrationStrategies } from 'rxdb';
import MigrationHelper from '../MigrationHelper';
import type { RiskAssessments } from './riskAssessment.types';

export const riskAssessmentMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: RiskAssessments) => {
    return MigrationHelper.instance.migrateRiskV1(oldDoc).then(response => {
      if (response) return { ...oldDoc, ...response };
      //if response if failed do not migrate data.
      return null;
    });
  },
};
